import { createStore, StoreCore } from "@priolo/jon";
import attachApi from "api/attachments";
import farmSo from "stores/farm";
import { getGrowUnitLayerName, getLayerByNumber } from "stores/growUnit/utils/layer";
import cropSo from "stores/library/crop";
import taskSo from "stores/task";
import { Attachment } from "types/Attachment";
import { AttachmentView } from "types/Attachment";



const setup = {

	state: {
		all: <Attachment[]>[],
		allView: <AttachmentView[]>[],

		/** SORT utilizzato nella lista di PHOTOS (e non in TABLE ATTACHMENT) */
		sortType: <SortType>"date",
		/** utile per capire se i dati sono stati gia' caricati per questa FARM */
		lastFarmId: <number>null,

		/** PHOTO selezionata */
		selected: <Attachment>null,
		dialogOpen: <boolean>false,
	},

	getters: {
		getByCycleUuid: (uuid: string, store?: PhotoStore) => {
			return store.state.all.filter(photo => photo.cycleUuid == uuid)
		},
		getByTaskUuid: (uuid: string, store?: PhotoStore) => {
			return store.state.all.filter(photo => photo.taskUuid == uuid)
		},
		getById: (id: number, store?: PhotoStore) => {
			return store.state.all.find(photo => photo.id == id)
		},
	},

	actions: {
		fetchAll: async (farmId: number, store?: PhotoStore) => {
			const { data } = await attachApi.index(farmId)
			store.setAll(data)
		},
		fetchAllIfVoid: async (farmId: number, store?: PhotoStore) => {
			if (store.state.lastFarmId == farmId && store.state.all?.length > 0) return
			await store.fetchAll(farmId)
		},
		fetchByCycle: async ({ farmId, cycleUuid }: { farmId: number, cycleUuid: string }, store?: PhotoStore) => {
			const { data } = await attachApi.index(farmId, cycleUuid)
			store.setCurrent(data)
		},
		updateView: (_: void, store?: PhotoStore): AttachmentView[] => {
			if ( !store.state.all ) return []
			const views:AttachmentView[] = store.state.all.map(attach => {
				// Get related data from other stores
				const growUnit = farmSo.getGrowUnitByCode(attach.growUnitCode)
				const layer = getLayerByNumber(growUnit, attach.layer?.layerNumber)
				const layerName = getGrowUnitLayerName(growUnit, layer)
				const task = taskSo.getByUuid(attach.taskUuid)
				const crop = cropSo.getByUuid(attach.cropUuid)

				// Transform data according to AttachmentView interface
				return <AttachmentView>{
					id: attach.id,
					farmId: attach.farmId,
					thumbUrl: attach.thumbnailTemporaryUrl,
					name: attach.name ?? "--",

					cropName: crop?.name,
					cropUuid: attach.cropUuid,

					cycleUuid: attach.cycleUuid,
					taskSubject: task?.subject,

					growUnitName: growUnit?.name,
					growUnitCode: attach.growUnitCode,

					layerName: layerName,
					phase: layer?.phase,
					trolleys: attach.layer?.trolleysPosition,
					type: attach.type,
					date: attach.eventTime,
					notes: attach.userNotes,
				} as AttachmentView
			})
			store.setAllView(views)
		}
	},

	mutators: {
		setAll: (all: Attachment[]) => ({ all }),
		setAllView: (allView: AttachmentView[]) => ({ allView }),
		setCurrent: (current: Attachment[]) => ({ current }),
		setSortType: (sortType: SortType) => ({ sortType }),
		setSelected: (selected: Attachment) => ({ selected }),
		setDialogOpen: (dialogOpen: boolean) => ({ dialogOpen }),
	},
}


export type PhotoState = typeof setup.state
export type PhotoGetters = typeof setup.getters
export type PhotoActions = typeof setup.actions
export type PhotoMutators = typeof setup.mutators
export interface PhotoStore extends StoreCore<PhotoState>, PhotoGetters, PhotoActions, PhotoMutators {
	state: PhotoState
}
const attachSo = createStore(setup) as PhotoStore
export default attachSo

export type SortType = "date" | "layer"

